const LINKS = [
  {
    href:
      'https://www.gradoo.com/de/impressum?utm_source=cc&utm_medium=default&utm_campaign=noCamp',
    i18n: {
      id: 'Sidebar.footer.imprint',
      defaultMessage: 'Imprint'
    }
  },
  {
    href:
      'https://www.gradoo.com/de/datenschutz?utm_source=cc&utm_medium=default&utm_campaign=noCamp',
    i18n: {
      id: 'Sidebar.footer.data.security',
      defaultMessage: 'Data security'
    }
  },
  {
    href:
      'https://www.gradoo.com/de/kontakt?utm_source=cc&utm_medium=default&utm_campaign=noCamp',
    i18n: {
      id: 'Sidebar.footer.contact.us',
      defaultMessage: 'Contact us'
    }
  }
]

export default LINKS



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/Footer/config/links.js